import { h } from 'preact';

const Youtube = (props) => {
	return (
		<svg {...props} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
			<g id="Icon/Social/Youtube" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="YouTube_light_icon_(2017)-(1)" transform="translate(2.000000, 5.000000)" fill={props.fill} fill-rule="nonzero">
					<path d="M9.99968473,0 C9.99968473,0 3.73992713,3.2172e-05 2.17486716,0.411796868 C1.33467703,0.6423851 0.642530502,1.33431066 0.411890077,2.19078126 C3.2179282e-05,3.75548712 -8.2915415e-17,7 0,7 C0,7 3.2179282e-05,10.2609836 0.411890077,11.8092187 C0.642530502,12.6656894 1.31820272,13.3412087 2.17486716,13.5717968 C3.75640158,14.0000322 9.99968473,14 9.99968473,14 C9.99968473,14 16.2599893,13.9999678 17.8250493,13.5882032 C18.6817138,13.3576148 19.3573861,12.6820957 19.5880264,11.825625 C19.9998842,10.2609192 19.9999164,7.01640632 19.9999164,7.01640632 C19.9999164,7.01640632 20.0163587,3.75548712 19.5880264,2.19078126 C19.3573861,1.33431066 18.6817138,0.658791364 17.8250493,0.428203132 C16.2599893,-3.216612e-05 9.99968473,8.28966516e-17 9.99968473,0 Z M8.0064213,4.00257816 L13.2122085,7 L8.0064213,9.99742184 L8.0064213,4.00257816 Z" id="path7"></path>
				</g>
			</g>
		</svg>
	);
};

export default Youtube;
